// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"252":"7e46c0e5","316":"be7bc317","354":"3840a68a","373":"4f007993","481":"e18d3832","488":"371f7511","595":"f313e442","601":"fa2e5f52","628":"899ed2c4","776":"e067bad3"}[chunkId] + ".chunk.js";
};